module.exports = __webpack_public_path__ + "img/qr-code-scan.4dd9d58f.svg";